import { useEffect } from "preact/hooks";
import { AccountPage } from "./ui/account-page";
import { CharacterPage } from "./ui/character-page";
import { Home } from "./ui/characters";
import { LibraryPage } from "./ui/library-page";
import { useRoute } from "./ui/router";
import { loadTheme } from "./ui/theme";

export function App() {
  const route = useRoute();
  useEffect(() => {
    void loadTheme();
  }, []);
  if (route.page === "character") return <CharacterPage id={route.id} />;
  if (route.page === "library") return <LibraryPage section={route.section} />;
  if (route.page === "account") return <AccountPage />;
  return <Home />;
}
